import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import axios from 'axios'
import useToken from '../App/useToken'
import LoadingSpinner from '../Helper/LoadingSpinner'
import { Access, hasAccess } from '../Helper/Helper'

export default function DownloadGeojsonPopup(props) {
  const [okToDownload, setOkToDownload] = useState(false)
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState('Starting to fetch data')
  const [href, setHref] = useState(null)

  const item = props.itemToDownload ? props.itemToDownload : null
  
  const {token, getCustomer} = useToken()
  const customer = getCustomer()
  const tryRequire = ()  => {
    
    setOkToDownload(false)
    var formData = new FormData();
    formData.append('token', token);
    formData.append('AID', props.itemToDownload.AID);
    formData.append('timeFrame', props.ctx.selectedTimeFrame);
    formData.append('customerId', props.itemToDownload.customerId);
    formData.append('forExport', true)
    const url = props.ctx.showShapeData?.current ? "file-handler/getStandGeojson" : "api/get_flight_geojson"
    // console.log(url)
    var config = {
      method: 'post',
      url: url,
      data: props.ctx.showShapeData?.current ? formData : {'token': token, 'id': props.itemToDownload._id}
  };
    axios(config)
     .then((res) => {
      if(props.ctx.showShapeData?.current && res && !hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number)){
        const taskId = res?.data?.task_id;
        const resStatus = res?.data?.status ? res.data?.status : 'Fetching data';
        setStatus(resStatus)
        if(taskId){
          pollStatus(taskId)
        }
      } else {
        if(res.data.geojson){
          // const json = JSON.stringify(res.data.trajectory, null, 2);
          
          const data = JSON.stringify(res.data.geojson) 
          const blob = new Blob([data], { type: "application/json" });
          // // console.log(blob)

          setHref(URL.createObjectURL(blob))
          // // console.log("setting download ok")
          setOkToDownload(true)
        } else {
          setHref(null)        
          // // console.log("setting download false")

          setOkToDownload(false)
        }
      }
    })
    .catch((err) => {
      setOkToDownload(false);
      setStatus("Failed to get data")
      setHref(null);
    });
  };
  const fetchStatus = async (taskId) => {
    const formData = new FormData();
    formData.append("token", token);

    const res = await axios.post(`file-handler/status/${taskId}`, formData);
    return res.data;
  };
  const pollStatus = (taskId) => {
    const interval = setInterval(async () => {
      try {
        const res = await fetchStatus(taskId)

        if (res?.status === "complete") {
          clearInterval(interval);
          fetchResult(taskId);
          setStatus('Fetching data')
        } else if (res?.status === "failed") {
          clearInterval(interval);
          setStatus('Failed to get data')
          
          setOkToDownload(false);
          setLoading(false)

          setHref(null);
        } else if (res?.status !== status) {
          setStatus(res?.status)
        }
      } catch (err) {
        clearInterval(interval);
        setOkToDownload(false);
        setLoading(false)
        setStatus("Failed to get data")


        setHref(null);
      }
    }, 3000);
  };
  const fetchResult = async (taskId) => {
    try {
      const formData = new FormData();
      formData.append("token", token);

      const res = await axios.post(`file-handler/result/${taskId}`, formData);

      const blob = new Blob([JSON.stringify(res.data)], {
        type: "application/json",
      });

      setHref(URL.createObjectURL(blob));
      setOkToDownload(true);
      setLoading(false)
    } catch (err) {
      setStatus("Failed to get data")
      setOkToDownload(false);
      setLoading(false)
      setHref(null);
    }
  };
  const name = okToDownload && props.itemToDownload ? props.ctx?.showShapeData?.current &&  props.ctx.selectedTimeFrame? props.itemToDownload.alias+"-"+props.ctx.selectedTimeFrame : props.itemToDownload.alias : ""

  let title = okToDownload ? "Download geojson data of stand" + props.itemToDownload ? props.ctx?.showShapeData?.current ?  props.itemToDownload?.alias +'-'+ props.ctx.selectedTimeFrame : props.itemToDownload?.alias : "CSV does not exist for this stand" : '' 
  useEffect(()=>{
    // console.log(props.downloadGeojsonDialogShow)
    // console.log(props.itemToDownload)
    if(props.downloadGeojsonDialogShow && props.itemToDownload){
        setStatus('Starting to fetch data')
        setLoading(true)
        tryRequire()
    }
  }, [props.downloadGeojsonDialogShow])
  return (
    <Modal
      show={props.downloadGeojsonDialogShow}
      onHide={() => {
        setOkToDownload(false)
        props.setDownloadGeojsonDialogShow(false)}}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    > 
      <div style={{backgroundColor: "#212529", color: "#ffffff"}}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {!okToDownload && (<><p>{status}</p> {loading &&<LoadingSpinner/>}</>)}
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button onClick={() => {
          setOkToDownload(false)
          props.setDownloadGeojsonDialogShow(false)}}>Cancel</Button>
          <Button
          disabled={!okToDownload} 
          href={href} 
          download={hasAccess(customer, Access.DOWNLOAD_GEOREFERENCED_DATA.number) ? name+'.geojson' : name+'_scrambled_data.geojson'} 
          onClick={() => { 
            props.setDownloadGeojsonDialogShow(false)}}>
              Download
          </Button>
      </Modal.Footer>
      </div>
    </Modal>
  );
}

DownloadGeojsonPopup.propTypes = {
  ctx: PropTypes.object.isRequired,
  itemToDownload: PropTypes.object.isRequired,
  downloadGeojsonDialogShow: PropTypes.object.isRequired,
  setDownloadGeojsonDialogShow: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired,
}